import { render } from "./PeerRanking.vue?vue&type=template&id=665dc265&scoped=true"
import script from "./PeerRanking.vue?vue&type=script&lang=ts"
export * from "./PeerRanking.vue?vue&type=script&lang=ts"

import "./PeerRanking.vue?vue&type=style&index=0&id=665dc265&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-665dc265"

export default script